import { IssueType, type IssueWithChildren } from '@momentum/types';

/**
 * Check if a goal has the hierarchy structure: Goal -> Goals -> Tasks
 * This means the goal should have child goals, and at least one of those
 * child goals should have tasks.
 *
 * @param goal The goal to check
 * @returns true if the goal can be exported to Excel, false otherwise
 */
export function hasGoalGoalsTasksHierarchy(goal: IssueWithChildren): boolean {
  if (!goal.children || goal.children.length === 0) {
    return false;
  }

  // Check if goal has at least one child goal (not task)
  const hasChildGoals = goal.children.some(
    (child) => child.type === IssueType.GOAL
  );

  if (!hasChildGoals) {
    return false;
  }

  // Check if at least one child goal has tasks
  const childGoals = goal.children.filter(
    (child) => child.type === IssueType.GOAL
  );

  const hasTasksInChildGoals = childGoals.some(
    (childGoal) =>
      childGoal.children &&
      childGoal.children.some(
        (grandChild) => grandChild.type === IssueType.TASK
      )
  );

  return hasTasksInChildGoals;
}
